import { postData } from 'frontend/utils/ajax';

export function updateProfileFlag(flagName: string, value = true): Promise<undefined> {
  const url = value ? `/profile/set_flag/${flagName}/` : `/profile/unset_flag/${flagName}/`;
  return postData(url);
}
